import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initializeGoogleAdsTag } from './utils/googleAds';
initializeGoogleAdsTag();
render(<ErrorBoundary data-id="element-1980" data-mp="21cacxxxtztcm">
    <App data-id="element-1981" data-mp="269aje9yley49" />
  </ErrorBoundary>, document.getElementById('root'));